import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlayerComponent } from '@pool-league/frontend-shared-ui-player';
import { CompetitionAttribute } from '../attribute';

@Component({
  selector: 'lib-web-competition-summary',
  imports: [CommonModule, PlayerComponent],
  templateUrl: './competition-summary.component.html',
  styleUrl: './competition-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompetitionSummaryComponent {
  readonly progress = input<{ played: number; total: number } | undefined>(
    undefined,
  );
  readonly attributes = input.required<CompetitionAttribute[]>();
  readonly winner = input<string | undefined>(undefined);
  readonly runnerUp = input<string | undefined>(undefined);
}
